import React, { Component } from 'react';
import $ from 'dom7';
import _ from 'lodash';
import './index.less';
import H from './img/H.png'
import E from './img/E.png'
import L from './img/L.png'
import O from './img/O.png'
/**
 * 使用方法
 *  <Navs selector='.page' />
 */
class Navs extends Component {
    constructor(props, context) {
        super(props, context);
        let me = this;
        me.state = {
            active: 0,
            count: 0
        };
        me.check = _.throttle(me.check, 500);
    }
    componentDidMount() {
        let me = this;
        me.setCount();

        window.onscroll = function () {
            me.check();
        };
    }
    setCount() {
        let me = this;
        let {
            selector
        } = me.props;
        me.setState({
            count: $(selector).length
        });
    }
    check() {
        let me = this;
        let {
            selector
        } = me.props;

        $(selector).map((i, page) => {
            let dom = page.getBoundingClientRect();
            if (Math.abs(dom.top) < 300) {
                me.setState({
                    active: i
                });
            }
        });
    }
    render() {
        let me = this;
        let arr = ['企业介绍','福利待遇','招聘对象','招聘岗位','招聘条件','招聘流程','注意事项'];
        let arr2 = [H,E,L,L,O,L,O];
        let link = ['#a1','#a2','#a3','#a4','#a5','#a6','#a7'];
        let {
            active, count
        } = me.state;
        let navs = [];
        for (let i = 0; i < count; i++) {
            navs.push(
                <div className={`navs__item ${active == i && 'navs__item--active'}`}>
                    {/* <img src={arr2[i]} /> */}
                    <a href={link[i]}>
                        {arr[i]}
                    </a>
                </div>
            );
        }
        return (
            <div className="navs">
                {navs}
            </div>
        );
    }
}

export default Navs;


// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/cmps/navs/index.js